import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as streamService from "../../services/stream.services";
import * as inquiriesService from "../../services/inquiry.services";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import Loader from "../../common/loader";
import Breadcrums from "../../common/breadcrumbs";
import {
  capitalizeFirstLetter,
  formateDateWithMonth,
  formateDateWithMonthAdmin,
  handleServerValidations,
  TrimText,
  usePermission,
} from "../../../../utils/commonfunction";
import CustomRangepicker from "../../common/rangepicker";
import Swal from "sweetalert2";
import { INQUIRY_STATUS, showFilterlist, SWAL_SETTINGS } from "../../../../utils/Constants";
import StatusFilter from "../../common/statusFilter";
import { Tooltip, Whisper, Placeholder, Modal } from "rsuite";
import * as $ from 'jquery';
import { useSearchParams } from "react-router-dom";
import LiveStreamDetail from "../../../user/pages/LiveStreams/Detail";

const StreamTable = () => {
  const { can } = usePermission();
  const { t } = useTranslation();
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [list, setList] = useState([]);

  const [statsupdate, setStatusUpdate] = useState("false");
  const [datalength, setDataLength] = useState("");
  const [itemperpage] = useState(10);
  const [sorting, setSorting] = useState({});
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [resetdate, setResetDate] = useState(false);
  const [searchParams] = useSearchParams();
  const [streamModal, setStreamModal] = useState({
    open: false,
    type: "", // "recorded" | "live" | "no_video"
    url: "",
    title: "",
    stream: null,
  });

  const handleWatchStream = (row) => {
    const videoUrl = row?.recording_url || row?.recorded_video;
    if (videoUrl) {
      setStreamModal({
        open: true,
        type: "recorded",
        url: videoUrl,
        title: row?.title || "Recorded Stream",
        stream: row,
      });
    } else if (row?.isLive) {
      setStreamModal({
        open: true,
        type: "live",
        url: "",
        title: row?.title || "Live Stream",
        stream: row,
      });
    } else {
      setStreamModal({
        open: true,
        type: "no_video",
        url: "",
        title: row?.title || "Stream Details",
        stream: row,
      });
    }
  };

  // const [search] = useState({});
  const [globalsearch, setGlobalSearch] = useState("");
  const [search, setSearch] = useState({
    ...(searchParams.get("status") ? { status: searchParams.get("status") } : {}),
  });
  console.log(search, 222);

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("sidebar_link_stream"), url: "" },
  ];
  const showInquiryFilterList = [
    { name: "list_heading_status", status__id: "" },
    { name: "Running", status__id: "running" },
    { name: "Completed", status__id: "completed" },
    { name: "Pending", status__id: "pending" },
  ];

  useEffect(() => {
    const getData = setTimeout(() => {

      if (search) {
        setLoader(true);
        const formData = new FormData();
        formData.append("page", params.pgno);
        formData.append("per_page", itemperpage);
        formData.append("sort", JSON.stringify(sorting));
        let searchPayload = { ...search };
        delete searchPayload.status;

        if (search?.status === "running") {
          searchPayload.isLive = true;
          searchPayload.isStreamCompleted = false;
        } else if (search?.status === "completed") {
          searchPayload.isStreamCompleted = true;
        } else if (search?.status === "pending") {
          searchPayload.isLive = false;
          searchPayload.isStreamCompleted = false;
        }

        if (search?.stream_type) {
          searchPayload.stream_type = search.stream_type;
        }

        formData.append("search", JSON.stringify(searchPayload));
        formData.append("global_search", globalsearch);
        streamService
          .List(formData)
          .then((data) => {
            setDataLength(data.data.total_records);
            // setSerialNo(data.data.offset);
            setList(data && data.data && data.data.list ? data?.data?.list : []);
            // console.log("data.data.=====>", data.data);

            setPage(data && data.data && data.data.page ? data.data.page : 1);
            setLoader(false);
          })
          .catch((error) => {
            console.log("error ====> ", error);
          });
      }

    }, 300);
    return () => clearTimeout(getData)

  }, [
    location,
    statsupdate,
    sorting,
    search,
    globalsearch,
    itemperpage,
    params.pgno,
  ]);


  const viewfunction = (row) => {
    navigate(
      `/admin/stream/view/${row._id}?page=1`
    );
  };

  const markResolve = (row, status) => {
    Swal.fire({
      customClass: "swal-wide",
      title: t("msg_are_you_sure"),
      text: t("confirm_inquiry_status_text"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("btn_yes_resolve"),
      cancelButtonText: t("btn_cancel")
    }).then((result) => {
      if (result.isConfirmed) {
        const formdata = new FormData();

        formdata.append("_id", row._id);
        formdata.append("status", status)
        inquiriesService.resolveInquiry(formdata)
          .then((response) => {
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              setStatusUpdate(!statsupdate);
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("deleteError");
          });
      }
    });
  }




  // sorting function start
  const handleSort = (e, column) => {
    setDefaultSorting(false);
    let sort = { order: 0, column: column };
    if (e.target.classList.contains("assc")) {
      sort.order = -1;
    } else {
      sort.order = 1;
    }
    setSorting(sort);
  };
  // sorting end

  // search or filter function

  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (!key) {
      setSearch({});
      return;
    }
    const valStr = value !== undefined && value !== null ? String(value).trim() : "";
    if (valStr.length > 0 && valStr.toLowerCase() !== "status" && valStr.toLowerCase() !== "stream type") {
      sr[key] = value;
    } else {
      delete sr[key];
    }
    if (params.pgno && params.pgno !== "1") {
      navigate("/admin/stream/list/1");
    }
    setSearch(sr);
  };

  // search or filter end

  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    setSearch({});
    setResetDate(!resetdate);
    if ($("#defaultstatus") && $("#defaultstatus")[0]) $("#defaultstatus")[0].selectedIndex = 0;
    if ($("#defaultstreamtype") && $("#defaultstreamtype")[0]) $("#defaultstreamtype")[0].selectedIndex = 0;
    if (params.pgno && params.pgno !== "1") {
      navigate("/admin/stream/list/1");
    }
  };

  // const goToEdit = (row) => {
  //   navigate(
  //     `/admin/testimonial-management/testimonial/${params.pgno}/edit/${row._id}`
  //   );
  // };

  const Deletefunction = (row) => {

    Swal.fire({
      customClass: 'swal-wide',
      title: t("msg_are_you_sure"),
      text: t("you_not_be_able_to_revert_this"),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#403fad',
      cancelButtonColor: '#f1388b',
      confirmButtonText: t("btn_yes_delete"),
      cancelButtonText: t("btn_cancel")
    }).then((result) => {
      if (result.isConfirmed) {
        let id = row._id;
        const formdata = new FormData();
        formdata.append("_id", id);
        streamService.Delete(formdata).then(response => {
          setStatusUpdate(!statsupdate)
          if (response.success) {
            Swal.fire({
              icon: 'success',
              text: response.message,
              ...SWAL_SETTINGS
            })

          } else {
            Swal.fire({
              icon: 'error',
              text: handleServerValidations(response),
              ...SWAL_SETTINGS
            })
          }
        }).catch((error) => {
          console.log("deleteError", error)
        });
      }
    })

  }

  const handleEndStream = (row) => {
    Swal.fire({
      customClass: "swal-wide",
      title: t("msg_are_you_sure"),
      text: "You want to end this live stream?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: "Yes, End it!",
      cancelButtonText: t("btn_cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        formData.append("_id", row._id);
        streamService
          .EndStream(formData)
          .then((response) => {
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              setStatusUpdate(!statsupdate);
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.error("End stream error:", error);
          });
      }
    });
  };

  const ChangeStatus = (data, Num) => {
    const formData = new FormData();
    formData.append("_id", JSON.stringify(data).replaceAll('"', ""));
    formData.append("isStreamApproved", Num);
    Swal.fire({
      customClass: "swal-wide",
      title: t("msg_are_you_sure"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("btn_yes"),
      cancelButtonText: t("btn_cancel")
    }).then((result) => {
      if (result.isConfirmed) {
        streamService
          .Status(formData)
          .then((response) => {
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              setStatusUpdate(!statsupdate);
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("error===>");
          });
      }
    });
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {/* table section */}
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">
                {t("sidebar_link_stream")}
              </h6>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">
                  <div className="form-group mb-0 rangepicker_container filter_design">
                    <i className="fa fa-search calender_icon"></i>
                    <input
                      type="search"
                      className="form-control"
                      value={globalsearch}
                      placeholder={t("input_placeholder_search")}
                      onChange={(e) => {
                        setGlobalSearch(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="me-3">
                  <CustomRangepicker
                    GetDateRange={(e) => {
                      prepareSearch("createdAt", e);
                    }}
                    resetdate={resetdate}
                  />
                </div>
                <div className="me-3">
                  <div className="form-group mb-0 filter_icon_container filter_design">
                    <i className="fa fa-filter mr-2 filter_icon"></i>
                    <div className="select-down-arrow">
                      <select
                        className="form-control cp text-capitalize"
                        id="defaultstreamtype"
                        value={search?.stream_type || ""}
                        onChange={(e) => prepareSearch("stream_type", e.target.value)}
                      >
                        <option value="">Stream Type</option>
                        <option value="live">Live</option>
                        <option value="recorded">Recorded</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="me-3">
                  <StatusFilter
                    data={showInquiryFilterList}
                    prepareSearch={prepareSearch}
                    selectedStatus={search?.status || ""}
                  />
                </div>

                <button
                  type="reset"
                  value="Reset"
                  onClick={resetFilter}
                  className="btn btn-warning float-right mr-2"
                >
                  {t("btn_reset_filter")}
                </button>
              </div>
            </div>
            {loader ?
              <Placeholder.Paragraph className="w-100" rowHeight={30} rowSpacing={5} active={true} rows={7} />
              :
              <>
                <div className="table-responsive min-h-400">
                  <table className="table table-bordered border-t0 table table-bordered card-table border-top text-nowrap w-100 text-nowrap w-100">
                    <thead>
                      <tr>
                        <th className="position-relative select_head">
                          <span>{t("list_heading_sno")}</span>
                        </th>


                        <th>
                          <div className="sorting_column">
                            <span>{t("list_heading_name")}</span>
                            <Sorting
                              sort={sorting}
                              handleSort={handleSort}
                              column="title"
                            />
                          </div>
                        </th>

                        <th>
                          <div className="sorting_column">
                            <span>{t("label_store_name")}</span>
                            <Sorting
                              sort={sorting}
                              handleSort={handleSort}
                              column="seller.store_name"
                            />
                          </div>
                        </th>

                        <th>
                          <div className="rating_head">
                            <span>{t("label_duration")}</span>
                          </div>
                        </th>



                        <th>
                          <div className="rating_head">
                            <span>{t("label_stream_type")}</span>
                          </div>
                        </th>


                        <th>
                          <div className="sorting_column">
                            <span>{t("label_streamStartedAt")}</span>
                            <Sorting
                              sort={sorting}
                              handleSort={handleSort}
                              column="streamStartedAt"
                            />
                          </div>
                        </th>
                        <th>
                          <div className="sorting_column">
                            <span>{t("label_streamEndedAt")}</span>
                            <Sorting
                              sort={sorting}
                              handleSort={handleSort}
                              column="streamEndedAt"
                            />
                          </div>
                        </th>

                        <th className="status_head">{t("list_heading_live_status")}</th>
                        {/* <th className="status_head">{t("list_heading_status")}</th> */}

                        <th className="action_head">{t("list_heading_action")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <>
                        {list.length ? (
                          list.map((row, i) => {
                            return (
                              <tr
                                key={i}
                              >

                                <td>
                                  {row ? ((page - 1) * itemperpage) + i + 1 : null}
                                </td>


                                <td>
                                  {row?.title ? (
                                    <div className="d-flex">
                                      {row?.title ? capitalizeFirstLetter(TrimText(row.title, 50)) : "N/A"}
                                    </div>
                                  ) : (
                                    <div className="d-flex">"N/A"</div>
                                  )}
                                </td>

                                <td>
                                  {row?.seller?.store_name ? (
                                    <div className="d-flex capitalize fw-medium">
                                      {capitalizeFirstLetter(TrimText(row?.seller?.store_name, 25))}
                                    </div>
                                  ) : (
                                    <div className="d-flex text-muted">N/A</div>
                                  )}
                                </td>




                                <td>
                                  {row?.duration ? (
                                    <div className="d-flex">{TrimText(row.duration, 50)}</div>
                                  ) : (
                                    <div className="d-flex">N/A</div>
                                  )}
                                </td>



                                <td>
                                  {row?.stream_type ? (
                                    <div className="d-flex">{capitalizeFirstLetter(row.stream_type)}</div>
                                  ) : (
                                    <div className="d-flex">N/A</div>
                                  )}
                                </td>


                                <td>
                                  {row.streamStartedAt
                                    ? formateDateWithMonthAdmin(row.streamStartedAt)
                                    : "N/A"}
                                </td>

                                <td>
                                  {row.streamEndedAt
                                    ? formateDateWithMonthAdmin(row.streamEndedAt)
                                    : "N/A"}
                                </td>
                                <td>
                                  {row ? (
                                    <div className="d-flex">
                                      {row.isLive
                                        ? t("Running")
                                        : row.isStreamCompleted
                                          ? t("Completed")
                                          : t("Pending")}
                                    </div>
                                  ) : (
                                    <div className="d-flex">N/A</div>
                                  )}
                                </td>
                                {/* {row?.stream_type !== 'live' && row?.stream_type !== 'Live'?
                                  <td>
                                <label className={"custom-switch cp" + (row.isStreamApproved !== true ? " e_none" : "")}>
                                <input className="custom-switch-input cp" type="checkbox" checked={row?.isStreamApproved === true} onChange={(e) => ChangeStatus(row?._id , row?.isStreamApproved === true ? false : true )} />
                                  <span className="custom-switch-indicator cp"></span>
                                </label>
                              </td>
                              : 
                              <td>
                                -
                              </td>
                              } */}

                                <td>
                                  <div className="btn-toolbar table-actions" role="toolbar" aria-label="Toolbar with button groups">
                                    <div className="btn-group btn-group-sm" role="group" aria-label="Second group">
                                      {/* Watch Stream Button (Live or Recorded) */}
                                      {row.isLive ? (
                                        <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{ fontWeight: 'bold' }}>Watch Live Stream</Tooltip>}>
                                          <button
                                            type="button"
                                            className="btn"
                                            style={{ backgroundColor: "#10b981", color: "#fff" }}
                                            onClick={() => handleWatchStream(row)}
                                          >
                                            <i className="ri-broadcast-line"></i>
                                          </button>
                                        </Whisper>
                                      ) : (row.recording_url || row.recorded_video) ? (
                                        <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{ fontWeight: 'bold' }}>Watch Recorded Stream</Tooltip>}>
                                          <button
                                            type="button"
                                            className="btn"
                                            style={{ backgroundColor: "#6366f1", color: "#fff" }}
                                            onClick={() => handleWatchStream(row)}
                                          >
                                            <i className="ri-play-circle-fill"></i>
                                          </button>
                                        </Whisper>
                                      ) : row.room_id ? (
                                        <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{ fontWeight: 'bold' }}>View Stream</Tooltip>}>
                                          <button
                                            type="button"
                                            className="btn"
                                            style={{ backgroundColor: "#e0e7ff", color: "#4338ca" }}
                                            onClick={() => handleWatchStream(row)}
                                          >
                                            <i className="ri-live-line"></i>
                                          </button>
                                        </Whisper>
                                      ) : null}

                                      {/* {can("/admin/stream/view") && ( */}
                                        <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{ fontWeight: 'bold' }}>View</Tooltip>}>
                                          <button type="button" className="btn view" onClick={() => { viewfunction(row); }}>
                                            <i className="ri-eye-fill"></i>
                                          </button>
                                        </Whisper>
                                      {/* )} */}
                                      {can("/admin/stream/delete") && (
                                        <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{ fontWeight: 'bold' }}>Delete</Tooltip>}>
                                          <button type="button" className="btn delete" onClick={() => { Deletefunction(row) }}>
                                            <i className="ri-delete-bin-6-fill"></i>
                                          </button>
                                        </Whisper>
                                      )}
                                      {row.isLive && (
                                        <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{ fontWeight: "bold" }}>End Stream</Tooltip>}>
                                          <button
                                            type="button"
                                            className="btn delete"
                                            style={{ backgroundColor: "#ffc107", color: "#000" }}
                                            onClick={() => {
                                              handleEndStream(row);
                                            }}>
                                            <i className="ri-stop-circle-fill"></i>
                                          </button>
                                        </Whisper>
                                      )}
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan={10} className="text-center">
                              {t("msg_no_records")}
                            </td>
                          </tr>
                        )}
                      </>
                    </tbody>
                  </table>
                </div>
                <div
                  className=""
                  id="example1_info"
                  role="status"
                  aria-live="polite"
                >
                  <b>
                    {t("msg_total_records")} : {datalength ? datalength : "0"}
                  </b>
                </div>
                {datalength && datalength > 0 ? (
                  <CustomPagination
                    datalength={datalength}
                    itemperpage={itemperpage}
                    currentPage={page}
                    setPage={setPage}
                    pageRoute={[
                      {
                        name: "Reataurant",
                        path: "/admin/stream/list",
                      },
                    ]}
                  />
                ) : (
                  ""
                )}
              </>
            }
          </div>
        </div>
      </div>

      {/* Stream Playback / Preview Modal */}
      <Modal
        open={streamModal.open}
        onClose={() => setStreamModal({ open: false, type: "", url: "", title: "", stream: null })}
        size={streamModal.type === "live" || streamModal.type === "recorded" ? "lg" : "md"}
        overflow={true}
      >
        <Modal.Header>
          <Modal.Title className="d-flex align-items-center flex-wrap gap-2">
            {streamModal.type === "recorded" ? (
              <i className="ri-play-circle-fill text-primary" style={{ fontSize: "22px" }}></i>
            ) : streamModal.type === "live" ? (
              <i className="ri-broadcast-line text-success" style={{ fontSize: "22px" }}></i>
            ) : (
              <i className="ri-live-line" style={{ fontSize: "22px", color: "#4338ca" }}></i>
            )}
            <span className="fw-bold">{streamModal.title || "Stream"}</span>

            {streamModal.type === "live" ? (
              <span className="badge bg-danger">LIVE</span>
            ) : streamModal.type === "recorded" ? (
              <span className="badge bg-primary">Recorded</span>
            ) : streamModal.stream?.isStreamCompleted ? (
              <span className="badge bg-secondary">Completed</span>
            ) : (
              <span className="badge bg-warning text-dark">Pending</span>
            )}

            {streamModal.stream?.seller?.store_name && (
              <span className="badge bg-light text-dark border">
                <i className="ri-store-2-line me-1"></i>
                {streamModal.stream.seller.store_name}
              </span>
            )}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ maxHeight: "75vh", overflowY: "auto", padding: "16px" }}>
          {streamModal.type === "recorded" && streamModal.url ? (
            <div className="text-center">
              <div
                style={{
                  backgroundColor: "#000",
                  borderRadius: "10px",
                  overflow: "hidden",
                  boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
                }}
              >
                <video
                  key={streamModal.url}
                  controls
                  autoPlay
                  src={streamModal.url}
                  style={{
                    width: "100%",
                    maxHeight: "55vh",
                    display: "block",
                    margin: "0 auto",
                  }}
                />
              </div>

              {/* Stream metadata below video */}
              <div className="mt-3 p-3 bg-light rounded text-start">
                <div className="row g-2 small">
                  <div className="col-sm-4">
                    <strong className="text-muted d-block">Store Name</strong>
                    <span className="fw-medium">{streamModal.stream?.seller?.store_name || "N/A"}</span>
                  </div>
                  <div className="col-sm-4">
                    <strong className="text-muted d-block">Duration</strong>
                    <span>{streamModal.stream?.duration ? `${streamModal.stream.duration} minutes` : "N/A"}</span>
                  </div>
                  <div className="col-sm-4">
                    <strong className="text-muted d-block">Stream Date</strong>
                    <span>
                      {streamModal.stream?.streamStartedAt
                        ? formateDateWithMonthAdmin(streamModal.stream.streamStartedAt)
                        : (streamModal.stream?.date ? formateDateWithMonthAdmin(streamModal.stream.date) : "N/A")}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ) : streamModal.type === "live" ? (
            <div style={{ borderRadius: "10px", overflow: "hidden", minHeight: "450px" }}>
              <LiveStreamDetail
                publisherID={streamModal.stream?.seller_id || streamModal.stream?.seller?._id}
                roomID={streamModal.stream?.room_id}
                streamId={streamModal.stream?._id}
                isEmbedded={true}
              />
            </div>
          ) : (
            <div className="text-center py-2">
              {streamModal.stream?.thumbnail ? (
                <div className="mb-3">
                  <img
                    src={streamModal.stream.thumbnail}
                    alt={streamModal.stream?.title || "Thumbnail"}
                    style={{
                      maxHeight: "220px",
                      maxWidth: "100%",
                      borderRadius: "8px",
                      objectFit: "cover",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    }}
                  />
                </div>
              ) : (
                <div
                  className="mb-3 py-4 bg-light rounded d-flex flex-column align-items-center justify-content-center text-muted mx-auto"
                  style={{ height: "160px", maxWidth: "420px" }}
                >
                  <i className="ri-movie-line" style={{ fontSize: "42px", opacity: 0.5 }}></i>
                  <span className="mt-2 small">No thumbnail available</span>
                </div>
              )}

              <div
                className={`alert ${streamModal.stream?.isStreamCompleted ? "alert-secondary" : "alert-warning"} d-inline-flex align-items-center gap-2 mb-3`}
                style={{ fontSize: "13px" }}
              >
                <i className={streamModal.stream?.isStreamCompleted ? "ri-information-line" : "ri-time-line"} style={{ fontSize: "16px" }}></i>
                <span>
                  {streamModal.stream?.isStreamCompleted
                    ? "This live stream has ended. No recording was saved for this session."
                    : "This stream is currently scheduled/pending and has not started broadcasting yet."}
                </span>
              </div>

              <div className="p-3 bg-light rounded text-start mx-auto" style={{ maxWidth: "460px" }}>
                <table className="table table-sm table-borderless mb-0 small">
                  <tbody>
                    <tr>
                      <th className="text-muted" style={{ width: "40%" }}>Store Name:</th>
                      <td className="fw-medium">{streamModal.stream?.seller?.store_name || "N/A"}</td>
                    </tr>
                    <tr>
                      <th className="text-muted">Stream Type:</th>
                      <td>{capitalizeFirstLetter(streamModal.stream?.stream_type || "Live")}</td>
                    </tr>
                    <tr>
                      <th className="text-muted">Duration:</th>
                      <td>{streamModal.stream?.duration ? `${streamModal.stream.duration} mins` : "N/A"}</td>
                    </tr>
                    <tr>
                      <th className="text-muted">Scheduled / Started:</th>
                      <td>
                        {streamModal.stream?.streamStartedAt
                          ? formateDateWithMonthAdmin(streamModal.stream.streamStartedAt)
                          : (streamModal.stream?.date ? formateDateWithMonthAdmin(streamModal.stream.date) : "N/A")}
                      </td>
                    </tr>
                    <tr>
                      <th className="text-muted">Stream Ended:</th>
                      <td>
                        {streamModal.stream?.streamEndedAt
                          ? formateDateWithMonthAdmin(streamModal.stream.streamEndedAt)
                          : "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th className="text-muted">Room ID:</th>
                      <td className="font-monospace text-muted">{streamModal.stream?.room_id || "N/A"}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer className="d-flex justify-content-between align-items-center">
          <div>
            {streamModal.stream?._id && (
              <button
                type="button"
                className="btn btn-sm btn-outline-primary"
                onClick={() => {
                  const id = streamModal.stream?._id;
                  setStreamModal({ open: false, type: "", url: "", title: "", stream: null });
                  navigate(`/admin/stream/view/${id}`);
                }}
              >
                <i className="ri-eye-line me-1"></i> View Full Details
              </button>
            )}
          </div>
          <button
            type="button"
            className="btn btn-sm btn-secondary"
            onClick={() => setStreamModal({ open: false, type: "", url: "", title: "", stream: null })}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default StreamTable;
